import React from "react"
import Img from "gatsby-image"
import BackgroundImage from 'gatsby-background-image'

const OtherHero = ({content, lastHero}) => {
  return (
    <div className="h-screen">
    <BackgroundImage
      Tag="section"
      style = {{
        width: "100vw",
        height: "100vh",
        objectFit: "cover",
        opacity: "0.5",
        zIndex: "-1"
      }}
      fluid={content.node.backgroundImage.fluid}
      backgroundColor={`#040e18`}
    >
      <div className="w-screen absolute bottom-0 text-white mb-8">
        <div className="mx-auto max-w-3/4">
          <h2 className="text-sm w-1/2">{content.node.contentParagraph}</h2>
          <Img imgStyle={{ height: "100%"}} fluid={content.node.titleSvg.fluid} />
        </div>
      </div>
      {
        lastHero ?
         <div className="mt-8 md:mt-0 md:order-1 absolute bottom-0 md:right-0 md:mx-4">
          <p className="text-right text-sm md:text-sm text-white">
            &copy; 2021 Made By Rise Limited. All rights reserved.
          </p>
         </div>
        : null
      }
      </BackgroundImage>
    </div>      
)}

export default OtherHero
